import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'empathy-copy-cards-confirmation',
  templateUrl: 'copy-cards-confirmation.component.html'
})
export class CopyCardsConfirmationComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<CopyCardsConfirmationComponent>) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-confirm__dialog');
    this.dialogRef.disableClose = true;
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
